import { Pipe, PipeTransform } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { IStartSigningProfile } from '@app/core/model/env-config.model';
import { ITransactionData } from '@app/transaction-builder/model/transaction-data.model';
import { SignersService } from '@app/transaction-builder/services/signers.service';

@Pipe({
  name: 'isTransactionDataComplete',
})
export class IsTransactionDataCompletePipe implements PipeTransform {
  constructor(private signersService: SignersService) {}

  transform(
    transactionData: ITransactionData,
    formGroup: FormGroup,
    profile: IStartSigningProfile
  ): boolean {
    return (
      profile &&
      this.isFormValid(formGroup) &&
      this.areAllSignFieldsReady(transactionData) &&
      this.areAllDocsNonDefault(transactionData, profile)
    );
  }

  private isFormValid(formGroup: FormGroup): boolean {
    return (
      formGroup.valid &&
      !!(formGroup.get('documents').get('clientsToDocs') as FormArray)?.controls?.length
    );
  }

  private areAllSignFieldsReady(transactionData: ITransactionData): boolean {
    return this.signersService.doAllSignersHaveSignFields(transactionData);
  }

  private areAllDocsNonDefault(
    transactionData: ITransactionData,
    profile: IStartSigningProfile
  ): boolean {
    if (!profile.template) {
      return true;
    }
    return transactionData.documentsData.every((documentData) => {
      const foundProfileDocumentData = profile.template.documentsData.find(
        (profileDocumentData) => profileDocumentData.cid === documentData.cid
      );
      if (foundProfileDocumentData) {
        return documentData.content !== foundProfileDocumentData.content;
      }
      return true;
    });
  }
}
